// client\src\services\authService.js

import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "../utils/baseApi";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const getToken = () => {
  return localStorage.getItem("token");
};

const register = (username, password, role) => {
  return axios.post(
    `${API_URL}/users/register`,
    {
      username,
      password,
      role,
    },
    { headers: authHeader() }
  );
};

const login = (username, password) => {
  return axios.post(`${API_URL}/users/login`, { username, password });
};

const getAllUsers = () => {
  return axios.get(`${API_URL}/users`, { headers: authHeader() });
};

const generateApiKey = (userId) => {
  return axios.post(
    `${API_URL}/users/generate-key`,
    { userId },
    { headers: authHeader() }
  );
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("apiKey");
};

const userService = {
  register,
  login,
  getToken,
  getAllUsers,
  generateApiKey,
  logout,
};

export default userService;
